/**
 * ReplyBar
 *
 * Shows above the input when replying to a message.
 * Displays the sender name and a truncated preview of the message.
 */

import { ArrowUturnLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function ReplyBar({ replyingTo, onCancel }) {
  if (!replyingTo) return null;

  return (
    <div className="border-t border-base-300 bg-base-200 px-4 py-2 flex items-center gap-2">
      <ArrowUturnLeftIcon className="w-4 h-4 text-primary flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <span className="text-xs font-semibold text-primary">{replyingTo.senderName}</span>
        <p className="text-xs text-base-content/60 truncate">{replyingTo.text}</p>
      </div>
      <button className="btn btn-ghost btn-xs btn-circle" onClick={onCancel}>
        <XMarkIcon className="w-3 h-3" />
      </button>
    </div>
  );
}
